
/* STAFF件数がLiquidの250件上限を超える場合は、Section Rendering APIで次ページを取得する。
 * current URLのpreview_theme_id等を保持し、公開テーマへの副作用を防止する。
 */
(function () {
  'use strict';
  if (window.__awStaffPaginationReady) return;
  window.__awStaffPaginationReady = true;

  function fixNewStyleButtons(cards) {
    var items = window.awStyleItems;
    var buttons = cards.flatMap(function (card) {
      return Array.from(card.querySelectorAll('[data-aw-staff-works]'));
    });
    if (!Array.isArray(items)) {
      if (!document.querySelector('[data-aw-style-grid]')) {
        buttons.forEach(function (button) {
          button.hidden = false;
          button.removeAttribute('data-aw-staff-works');
        });
      }
      return;
    }
    var handles = new Set(items.filter(function (x) {
      return x && x.image && x.staffHandle;
    }).map(function (x) {
      return String(x.staffHandle);
    }));
    buttons.forEach(function (button) {
      var actions = button.parentElement;
      if (handles.has(button.dataset.awStaffWorks)) {
        button.removeAttribute('data-aw-staff-works');
        button.hidden = false;
      } else {
        button.remove();
        if (actions && !actions.children.length) actions.remove();
      }
    });
  }

  async function initOne(root) {
    if (root.dataset.staffPagerInitialized === 'true') return;
    root.dataset.staffPagerInitialized = 'true';

    var grid = root.querySelector('.aw-staff-grid');
    var sectionId = root.dataset.sectionId;
    if (!grid || !sectionId) return;

    var nextUrl = root.dataset.staffNextUrl || '';
    if (!nextUrl) return;

    var fallback = root.querySelector('.aw-staff-pagination-fallback');
    var seen = new Set(
      Array.from(grid.querySelectorAll('.aw-staff-card[data-staff-handle]'))
        .map(function (x) { return x.dataset.staffHandle; })
    );
    var added = [];
    var page = 0;

    try {
      while (nextUrl && page < 20) {
        page++;
        var target = new URL(window.location.href);
        var next = new URL(nextUrl, window.location.origin);

        next.searchParams.forEach(function (value, key) {
          target.searchParams.set(key, value);
        });
        target.searchParams.set('section_id', sectionId);

        var response = await fetch(target.toString(), {
          credentials: 'same-origin'
        });
        if (!response.ok) {
          throw new Error('STAFFページの読み込みエラー: ' + response.status);
        }

        var markup = await response.text();
        var dom = new DOMParser().parseFromString(markup, 'text/html');
        var chunk = Array.from(dom.querySelectorAll('[data-aw-staff-pagination]'))
          .find(function (node) {
            return node.dataset.sectionId === sectionId;
          });
        if (!chunk) break;

        Array.from(chunk.querySelectorAll('.aw-staff-grid > .aw-staff-card'))
          .forEach(function (card) {
            var handle = card.dataset.staffHandle;
            if (handle && !seen.has(handle)) {
              seen.add(handle);
              grid.appendChild(card);
              added.push(card);
            }
          });

        nextUrl = chunk.dataset.staffNextUrl || '';
      }

      if ((root.dataset.staffSort === 'true' || root.dataset.staffSort === 'rank') && added.length) {
        Array.from(grid.children).sort(function (a, b) {
          if (root.dataset.staffSort === 'rank') {
            var rankA = a.querySelectorAll('.aw-staff-card__stars img').length;
            var rankB = b.querySelectorAll('.aw-staff-card__stars img').length;
            if (rankB !== rankA) return rankB - rankA;
            return (Number(a.dataset.staffOrder) || 999999) -
              (Number(b.dataset.staffOrder) || 999999);
          }
          var roleA = Number(a.dataset.staffRolePriority || 99);
          var roleB = Number(b.dataset.staffRolePriority || 99);
          var roleDifference = roleA - roleB;
          if (roleDifference) return roleDifference;
          // SALON: role > star rank descending > original display_order.
          var starsA = a.querySelectorAll('.aw-staff-card__stars img').length;
          var starsB = b.querySelectorAll('.aw-staff-card__stars img').length;
          if (starsB !== starsA) return starsB - starsA;
          return (Number(a.dataset.staffOrder) || 999999) -
            (Number(b.dataset.staffOrder) || 999999);
        }).forEach(function (card) {
          grid.appendChild(card);
        });
      }

      fixNewStyleButtons(added);
      if (!grid.querySelector('.aw-staff-card')) root.hidden = true;
    } catch (error) {
      console.error('[DAY BY DAY STAFF pagination]', error);
      if (fallback && nextUrl) {
        fallback.href = nextUrl;
        fallback.hidden = false;
      }
    }
  }

  function initAll(scope) {
    Array.from((scope || document).querySelectorAll('[data-aw-staff-pagination]'))
      .forEach(function (root) { initOne(root); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
